import { userLogin } from "api/users";
import { get2FTAuthVerify , get2FADataAuth , get2FTAuthFront } from "api/graphQL_users";
import { useEffect, useRef, useState } from "react";
import { toast } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { setToken } from "utils/auth";
import Recover from "views/admin/profile/components/Recover";
import TwoFactorAuthentication from "views/admin/profile/components/TwoFactorAuthenticationLogin";

export default function SignIn() {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [setupLoading, isSetupLoading] = useState<boolean>(false);

  const [model2FA, setModel2FA] = useState<any>("");
  const [errEmail, setErrEmail] = useState("");
  const [errPassword, setErrPassword] = useState("");
  const [data, setData] = useState<any>();
  const [loginData, getLoginData] = useState<any>("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errAuthCode, setErrAuthCode] = useState("");
  const [status, setStatus] = useState("Login");
  const [is2FAReady, setIs2FAReady] = useState(false);
  const [passwordShow, setPasswordShow] = useState(false);
  const [authCode, setAuthCode] = useState(["", "", "", "", "", ""]);
  const inputRefs = useRef<Array<HTMLInputElement | null>>(new Array(6).fill(null));

  const [FAData, setFAData] = useState<any>();

  const [copy, setCopy] = useState(false);
  const [copyKey, setCopyKey] = useState(false);

  useEffect(() => {
    if (status === "OTP" && inputRefs.current[0]) inputRefs.current[0]?.focus();
  }, [status]);

  function handleEmailChange(e: any) { setEmail(e.target.value); setErrEmail(""); }
  function handlePasswordChange(e: any) { setPassword(e.target.value); setErrPassword(""); }

  const handleChange = (index: number, e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    if (/^\d$/.test(value) || value === "") {
      const newCode = [...authCode];
      newCode[index] = value;
      setAuthCode(newCode);
      if (value !== "" && index < 5 && inputRefs.current[index + 1]) inputRefs.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (index: number, e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Backspace" && authCode[index] === "" && index > 0) inputRefs.current[index - 1]?.focus();
  };

  function validateData() {
    if (!email) { setErrEmail("Please enter your email"); return false; }
    if (!password) { setErrPassword("Please enter your password"); return false; }
    if (password.length < 8) { setErrPassword("Password must be at least 8 characters"); return false; }
    return true;
  }

  function validateDataOtp() {
    if (!authCode) { setErrAuthCode("Please enter your OTP"); return false; }
    if (authCode.length < 6) { setErrAuthCode("OTP must be 6 digits"); return false; }
    return true;
  }

  async function handleSubmit(e: any) {
    e.preventDefault();
    if (!validateData()) return;
    try {
      setIsLoading(true);
      await userLogin({ email, password })
        .then((data) => {

          if(!data?.auth_2fa) {
            setIs2FAReady(false)
            get2FADataAuth(data?.user_id).then((d) => { setFAData(d); console.log("d",d) }).finally();
            getLoginData(data);
            setStatus("SET2FA");

          } else if (data?.auth_2fa) { 

            getLoginData(data); 
            setStatus("OTP"); 

          } else { 

            setToken(data.auth_token); 
            navigate("/admin/dashboard"); 

          }
        })
        .catch((err) => toast.error(err?.response?.data?.message ?? "Please provide valid values"))
        .finally(() => setIsLoading(false));
    } catch (err: any) {
      toast.error(err?.response?.data?.message ?? "Login failed");
      setIsLoading(false);
    }
  }

  const handleVerify = async (code: string) => {
    if (!validateDataOtp()) return;
    try {
      setIsLoading(true);
      await get2FTAuthVerify({ otp: code, user_id: loginData?.user_id, secret_key: loginData?.secret_key, inside_flag: true })
        .then((data) => {
          if (data.status === "false") toast.error(data.message);
          else { setToken(data.auth_token); toast.success("Login successfully"); navigate("/admin/dashboard"); }
        })
        .catch((err) => toast.error(err?.response?.data?.message ?? "Please provide valid values"))
        .finally(() => setIsLoading(false));
    } catch (err: any) {
      toast.error(err?.response?.data?.message ?? "Login failed");
      setIsLoading(false);
    }
  };

  const handleSubmit2FA = (e: React.FormEvent) => { e.preventDefault(); handleVerify(authCode.join("")); };

  const handlePaste = (e: React.ClipboardEvent<HTMLInputElement>) => {
    e.preventDefault();
    const pasted = e.clipboardData.getData("text").trim();
    if (/^\d{6}$/.test(pasted)) { setAuthCode(pasted.split("")); inputRefs.current[5]?.focus(); }
  };

  const copyToClipboard = (text: string, setter: (v: boolean) => void) => {
    navigator.clipboard.writeText(text);
    setter(true);
    setTimeout(() => setter(false), 1500);
  };

  const handleCompleteSetup = async(code:string) => {
    setIsLoading(true)

    if (code == undefined || code == "" || code == null) {
      toast.error("Please enter the code")
      setIsLoading(false)
      return;
    } else {
      get2FTAuthFront({
        enable_2FA: true,
        secret_key: FAData?.secret_key,
        recover_key: FAData?.recover_key,
        user_id: loginData?.user_id,
      }).then(async() => {
        await get2FTAuthVerify({ otp: code, user_id: loginData?.user_id, secret_key: FAData?.secret_key, inside_flag: true })
        .then((data) => {
          if (data.status === "false") toast.error(data.message);
          else { setToken(data.auth_token); toast.success("Login successfully"); navigate("/admin/dashboard"); }
        })
        .catch((err) => toast.error(err?.response?.data?.message ?? "Please provide valid values"))
        .finally(() => setIsLoading(false));
      }).catch((err) => toast.error(err?.response?.data?.message ?? "Something went wrong"));
    }
    
  }

  const handleSubmit2FASetup = (e: React.FormEvent) => { e.preventDefault(); handleCompleteSetup(authCode.join("")); };

  return (
    <div className="si-outer">
      {status === "Login" ? (
        <div className="si-box" key="login">

          {/* ── Header ── */}
          <div className="si-hd">
            <div className="si-hd-badge">
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/>
              </svg>
              Secure Login
            </div>
            <h1 className="si-title">Sign in to your account</h1>
            <p className="si-sub">Access your payment dashboard and manage your transactions.</p>
          </div>

          {/* ── Form ── */}
          <form onSubmit={handleSubmit} className="si-form" noValidate>

            <div className="si-field">
              <label className="si-lbl" htmlFor="email">Email address</label>
              <div className="si-inp-wrap">
                <span className="si-inp-icon">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="2" y="4" width="20" height="16" rx="2"/><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/>
                  </svg>
                </span>
                <input
                  id="email"
                  type="email"
                  placeholder="you@company.com"
                  value={email}
                  onChange={handleEmailChange}
                  autoComplete="email"
                  className={`si-inp${errEmail ? " si-inp--err" : ""}`}
                />
              </div>
              {errEmail && (
                <p className="si-err-msg">
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
                  {errEmail}
                </p>
              )}
            </div>

            <div className="si-field">
              <div className="si-lbl-row">
                <label className="si-lbl" htmlFor="password">Password</label>
              </div>
              <div className="si-inp-wrap">
                <span className="si-inp-icon">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/>
                  </svg>
                </span>
                <input
                  id="password"
                  type={passwordShow ? "text" : "password"}
                  placeholder="Min. 8 characters"
                  value={password}
                  onChange={handlePasswordChange}
                  autoComplete="current-password"
                  className={`si-inp${errPassword ? " si-inp--err" : ""}`}
                />
                <button type="button" className="si-eye-btn" onClick={() => setPasswordShow(!passwordShow)} aria-label="Toggle password visibility">
                  {passwordShow ? (
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M9.88 9.88a3 3 0 1 0 4.24 4.24"/>
                      <path d="M10.73 5.08A10.43 10.43 0 0 1 12 5c7 0 10 7 10 7a13.16 13.16 0 0 1-1.67 2.68"/>
                      <path d="M6.61 6.61A13.526 13.526 0 0 0 2 12s3 7 10 7a9.74 9.74 0 0 0 5.39-1.61"/>
                      <line x1="2" y1="2" x2="22" y2="22"/>
                    </svg>
                  ) : (
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z"/>
                      <circle cx="12" cy="12" r="3"/>
                    </svg>
                  )}
                </button>
              </div>
              {errPassword && (
                <p className="si-err-msg">
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
                  {errPassword}
                </p>
              )}
            </div>

            <button type="submit" className="si-btn" disabled={isLoading}>
              {isLoading ? (
                <span className="si-spinner" />
              ) : (
                <>
                  <span>Sign in</span>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M5 12h14M12 5l7 7-7 7"/>
                  </svg>
                </>
              )}
            </button>
          </form>

          {/* ── Security note ── */}
          <div className="si-security-note">
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
            </svg>
            <span>Protected by 256-bit SSL encryption</span>
          </div>
        </div>
      ) : status === 'SET2FA' || status === 'SETUPVERIFY' ? (
        <>
          <div className="si2-box" key="otp">
            <div className="si2-hd">
              <div className="si2-hd-badge si-hd-badge--green">
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
                </svg>
                Two-Factor Authentication
              </div>
              <h1 className="si2-title">Secure your account with 2FA</h1>
              <p className="si2-sub">Open your authenticator app and scan qr code or enter secret key to add your 2fa account.</p>
            </div>
            <div className="tfa2-body">
              {/* Section 1 */}
              <div className="tfa2-section">
                <div className="tfa2-section-header">
                  <div className="tfa2-section-num">1</div>
                  <h3 className="tfa2-section-title">Configure your authenticator app</h3>
                </div>
                <div className="tfa2-app-row">
                  {[
                    { name: "Google Authenticator", platforms: "iOS · Android" },
                    { name: "Authy", platforms: "iOS · Android · Desktop" },
                  ].map((app) => (
                    <div key={app.name} className="tfa2-app-card">
                      <div className="tfa2-app-icon">
                        <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
                          <rect x="5" y="2" width="14" height="20" rx="2"/><line x1="12" y1="18" x2="12.01" y2="18"/>
                        </svg>
                      </div>
                      <div>
                        <p className="tfa2-app-name">{app.name}</p>
                        <p className="tfa2-app-platforms">{app.platforms}</p>
                      </div>
                    </div>
                  ))}
                </div>
                <ol className="tfa2-steps-list">
                  <li>Install Google Authenticator or Authy on your device.</li>
                  <li>Open the app and tap the <strong>+</strong> icon to add a new account.</li>
                  <li>Choose <em>"Scan a QR code"</em> and point your camera below.</li>
                </ol>
              </div>
  
              {/* Section 2 */}
              <div className="tfa2-section">
                <div className="tfa2-section-header">
                  <div className="tfa2-section-num">2</div>
                  <h3 className="tfa2-section-title">Scan QR Code</h3>
                </div>
                <div className="tfa2-qr-wrap">
                  <div className="tfa2-qr-frame">
                    <img src={`data:image/png;base64 , ${FAData?.base64_image}`} alt="QR Code for 2FA" className="tfa2-qr-img" />
                  </div>
                  <div className="tfa2-qr-meta">
                    <p className="tfa2-qr-hint">Point your authenticator app at this QR code to link your account.</p>
                    <div className="tfa2-key-row">
                      <p className="tfa2-key-label">Secret Key</p>
                      <div className="tfa2-key-value-row">
                        <code className="tfa2-key-code">{FAData?.secret_key}</code>
                        <button className={`tfa2-copy-btn${copyKey ? " tfa2-copy-btn--copied" : ""}`} onClick={() => copyToClipboard(FAData?.secret_key, setCopyKey)}>
                          {copyKey ? <><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>Copied</> : <><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>Copy</>}
                        </button>
                      </div>
                    </div>
                    {!model2FA && (
                      <div className="tfa2-key-row">
                        <p className="tfa2-key-label">Recovery Key<span className="tfa2-key-badge">Save this!</span></p>
                        <div className="tfa2-key-value-row">
                          <code className="tfa2-key-code">{FAData?.recover_key}</code>
                          <button className={`tfa2-copy-btn${copy ? " tfa2-copy-btn--copied" : ""}`} onClick={() => copyToClipboard(FAData?.recover_key, setCopy)}>
                            {copy ? <><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>Copied</> : <><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>Copy</>}
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              
              <form onSubmit={handleSubmit2FASetup} className="si-form mt-10">
                <div className="si-otp-group">
                  {authCode.map((digit, index) => (
                    <input
                      key={index}
                      ref={(el) => (inputRefs.current[index] = el)}
                      type="text"
                      inputMode="numeric"
                      maxLength={1}
                      value={digit}
                      onChange={(e) => handleChange(index, e)}
                      onKeyDown={(e) => handleKeyDown(index, e)}
                      onPaste={index === 0 ? handlePaste : undefined}
                      className={`si-otp-inp${digit ? " si-otp-inp--filled" : ""}`}
                      aria-label={`Digit ${index + 1}`}
                    />
                  ))}
                </div>

                {errAuthCode && (
                  <p className="si-err-msg si-err-msg--center">
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
                    {errAuthCode}
                  </p>
                )}

                <button type="submit" className="si-btn" disabled={isLoading}>
                  {isLoading ? <span className="si-spinner" /> : (
                    <>
                      <span>Verify &amp; Continue</span>
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M5 12h14M12 5l7 7-7 7"/>
                      </svg>
                    </>
                  )}
                </button>
              </form>

              <div className="si-otp-footer">
                <button onClick={() => {setStatus("Login"); setAuthCode(["", "", "", "", "", ""]); }} className="si-back-btn">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M19 12H5M12 19l-7-7 7-7"/></svg>
                  Back to login
                </button>
              </div>
               
            </div>
          </div>
        </>
      ) : (
        /* ── 2FA ── */
        <div className="si-box" key="otp">
          <div className="si-hd">
            <div className="si-hd-badge si-hd-badge--green">
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
              </svg>
              Two-Factor Authentication
            </div>
            <h1 className="si-title">Verify your identity</h1>
            <p className="si-sub">Open your authenticator app and enter the 6-digit code to continue.</p>
          </div>

          <form onSubmit={handleSubmit2FA} className="si-form">
            <div className="si-otp-group">
              {authCode.map((digit, index) => (
                <input
                  key={index}
                  ref={(el) => (inputRefs.current[index] = el)}
                  type="text"
                  inputMode="numeric"
                  maxLength={1}
                  value={digit}
                  onChange={(e) => handleChange(index, e)}
                  onKeyDown={(e) => handleKeyDown(index, e)}
                  onPaste={index === 0 ? handlePaste : undefined}
                  className={`si-otp-inp${digit ? " si-otp-inp--filled" : ""}`}
                  aria-label={`Digit ${index + 1}`}
                />
              ))}
            </div>

            {errAuthCode && (
              <p className="si-err-msg si-err-msg--center">
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
                {errAuthCode}
              </p>
            )}

            <button type="submit" className="si-btn" disabled={isLoading}>
              {isLoading ? <span className="si-spinner" /> : (
                <>
                  <span>Verify &amp; Login</span>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M5 12h14M12 5l7 7-7 7"/>
                  </svg>
                </>
              )}
            </button>
          </form>

          <div className="si-otp-footer">
            <Recover status={status} data={data} loginData={loginData} setModel2FA={setModel2FA} setData={setData} />
            {model2FA && (
              <TwoFactorAuthentication status={status} data={data} model2FA={model2FA} setModel2FA={setModel2FA} />
            )}
            <button onClick={() => {setStatus("Login"); setAuthCode(["", "", "", "", "", ""]); }} className="si-back-btn">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M19 12H5M12 19l-7-7 7-7"/></svg>
              Back to login
            </button>
          </div>
        </div>
      )}

      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@300;400;500;600;700;800&display=swap');

        .si-outer {
          font-family: 'Plus Jakarta Sans', sans-serif;
          width: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .tfa2-confirm-box {
          margin-top: 22px;
          padding: 16px;
          background: #f8fafc;
          border: 1px solid #e2e8f0;
          border-radius: 12px;
        }

        .tfa2-confirm-label {
          display: flex;
          align-items: flex-start;
          gap: 10px;
          cursor: pointer;
          font-size: 12.5px;
          line-height: 1.5;
          color: #475569;
          font-weight: 500;
        }

        .tfa2-confirm-label input {
          width: 17px;
          height: 17px;
          margin: 1px 0 0;
          flex-shrink: 0;
          accent-color: #2563eb;
          cursor: pointer;
        }

        .tfa2-confirm-box .tfa2-btn-verify {
          width: 100%;
          justify-content: center;
          margin-top: 14px;
        }

        .tfa2-confirm-box .tfa2-btn-verify:disabled {
          opacity: 0.5;
          cursor: not-allowed;
          transform: none;
          box-shadow: none;
        }

        /* ── Card box ── */
        .si2-box {
          width: 100%;
          max-width: 600px;
          animation: siIn 0.5s cubic-bezier(0.16,1,0.3,1) both;
        }
        @keyframes siIn {
          from { opacity: 0; transform: translateY(16px); }
          to   { opacity: 1; transform: translateY(0); }
        }

        .si2-hd-badge {
          display: inline-flex;
          align-items: center;
          gap: 6px;
          background: #eff6ff;
          color: #1d4ed8;
          border: 1px solid #bfdbfe;
          border-radius: 100px;
          font-size: 11.5px;
          font-weight: 600;
          padding: 5px 12px;
          letter-spacing: 0.2px;
          margin-bottom: 18px;
        }
        .si2-hd-badge--green {
          background: #f0fdf4;
          color: #15803d;
          border-color: #bbf7d0;
        }

        .si2-title {
          font-size: clamp(22px, 3vw, 28px);
          font-weight: 800;
          color: #0f172a;
          letter-spacing: -0.5px;
          line-height: 1.2;
          margin-bottom: 8px;
        }
        .si2-sub {
          font-size: 14px;
          color: #64748b;
          line-height: 1.6;
        }

        /* ── Card box ── */
        .si-box {
          width: 100%;
          max-width: 440px;
          animation: siIn 0.5s cubic-bezier(0.16,1,0.3,1) both;
        }
        @keyframes siIn {
          from { opacity: 0; transform: translateY(16px); }
          to   { opacity: 1; transform: translateY(0); }
        }

        /* ── Header ── */
        .si-hd { margin-bottom: 32px; }

        .si-hd-badge {
          display: inline-flex;
          align-items: center;
          gap: 6px;
          background: #eff6ff;
          color: #1d4ed8;
          border: 1px solid #bfdbfe;
          border-radius: 100px;
          font-size: 11.5px;
          font-weight: 600;
          padding: 5px 12px;
          letter-spacing: 0.2px;
          margin-bottom: 18px;
        }
        .si-hd-badge--green {
          background: #f0fdf4;
          color: #15803d;
          border-color: #bbf7d0;
        }

        .si-title {
          font-size: clamp(22px, 3vw, 28px);
          font-weight: 800;
          color: #0f172a;
          letter-spacing: -0.5px;
          line-height: 1.2;
          margin-bottom: 8px;
        }
        .si-sub {
          font-size: 14px;
          color: #64748b;
          line-height: 1.6;
        }

        /* ── Form ── */
        .si-form { display: flex; flex-direction: column; gap: 20px; }

        /* ── Field ── */
        .si-field { display: flex; flex-direction: column; gap: 6px; }
        .si-lbl-row { display: flex; justify-content: space-between; align-items: center; }
        .si-lbl {
          font-size: 13px;
          font-weight: 600;
          color: #374151;
        }

        /* ── Input ── */
        .si-inp-wrap { position: relative; display: flex; align-items: center; }
        .si-inp-icon {
          position: absolute; left: 14px;
          color: #94a3b8;
          display: flex; align-items: center; pointer-events: none;
        }
        .si-inp {
          width: 100%;
          padding: 13px 44px 13px 42px;
          background: #f8fafc;
          border: 1.5px solid #e2e8f0;
          border-radius: 12px;
          font-family: 'Plus Jakarta Sans', sans-serif;
          font-size: 15px;
          color: #0f172a;
          outline: none;
          transition: border-color 0.18s, box-shadow 0.18s, background 0.18s;
          -webkit-appearance: none;
        }
        .si-inp::placeholder { color: #cbd5e1; }
        .si-inp:hover { border-color: #cbd5e1; background: #f1f5f9; }
        .si-inp:focus {
          border-color: #2563eb;
          background: #ffffff;
          box-shadow: 0 0 0 3px rgba(37,99,235,0.1);
        }
        .si-inp--err {
          border-color: #ef4444 !important;
          background: #fff7f7 !important;
          box-shadow: 0 0 0 3px rgba(239,68,68,0.08) !important;
        }

        .si-eye-btn {
          position: absolute; right: 14px;
          background: none; border: none; cursor: pointer;
          color: #94a3b8; display: flex; align-items: center; padding: 4px;
          transition: color 0.18s;
          border-radius: 6px;
        }
        .si-eye-btn:hover { color: #475569; }

        /* ── Error ── */
        .si-err-msg {
          display: flex; align-items: center; gap: 5px;
          font-size: 12px; color: #dc2626; font-weight: 500;
        }
        .si-err-msg--center { justify-content: center; }

        /* ── Submit button ── */
        .si-btn {
          width: 100%;
          padding: 14px 24px;
          background: linear-gradient(135deg, #1d4ed8 0%, #2563eb 100%);
          border: none; border-radius: 12px;
          font-family: 'Plus Jakarta Sans', sans-serif;
          font-size: 15px; font-weight: 700; color: #fff;
          cursor: pointer;
          display: flex; align-items: center; justify-content: center; gap: 8px;
          transition: transform 0.15s, box-shadow 0.18s, opacity 0.18s;
          box-shadow: 0 4px 14px rgba(37,99,235,0.3), 0 1px 3px rgba(37,99,235,0.2);
          position: relative; overflow: hidden;
          -webkit-tap-highlight-color: transparent;
          letter-spacing: 0.1px;
        }
        .si-btn::after {
          content: '';
          position: absolute; inset: 0;
          background: linear-gradient(135deg, rgba(255,255,255,0.1), transparent 60%);
        }
        .si-btn:hover {
          transform: translateY(-1px);
          box-shadow: 0 8px 24px rgba(37,99,235,0.38), 0 2px 6px rgba(37,99,235,0.2);
        }
        .si-btn:active { transform: translateY(0); }
        .si-btn:disabled { opacity: 0.65; cursor: not-allowed; transform: none; }

        /* ── Spinner ── */
        .si-spinner {
          display: inline-block; width: 18px; height: 18px;
          border: 2px solid rgba(255,255,255,0.35);
          border-top-color: #fff; border-radius: 50%;
          animation: siSpin 0.65s linear infinite;
        }
        @keyframes siSpin { to { transform: rotate(360deg); } }

        /* ── Security note ── */
        .si-security-note {
          display: flex; align-items: center; justify-content: center; gap: 6px;
          margin-top: 20px;
          font-size: 12px; color: #94a3b8; font-weight: 500;
        }

        /* ── Divider ── */
        .si-divider {
          display: flex; align-items: center; gap: 12px;
          font-size: 12px; color: #cbd5e1; font-weight: 500;
        }
        .si-divider::before, .si-divider::after {
          content: ''; flex: 1; height: 1px; background: #f1f5f9;
        }

        /* ── OTP ── */
        .si-otp-group {
          display: flex; justify-content: center; gap: 10px;
        }
        .si-otp-inp {
          width: 54px; height: 62px;
          background: #f8fafc;
          border: 1.5px solid #e2e8f0;
          border-radius: 14px;
          font-family: 'Plus Jakarta Sans', sans-serif;
          font-size: 24px; font-weight: 700;
          color: #0f172a; text-align: center; outline: none;
          transition: border-color 0.18s, box-shadow 0.18s, background 0.18s;
          -webkit-appearance: none; caret-color: #2563eb;
        }
        .si-otp-inp:focus {
          border-color: #2563eb;
          background: #fff;
          box-shadow: 0 0 0 3px rgba(37,99,235,0.1);
        }
        .si-otp-inp--filled {
          border-color: #93c5fd;
          background: #eff6ff;
          color: #1d4ed8;
        }

        /* ── OTP footer ── */
        .si-otp-footer {
          margin-top: 24px;
          display: flex; justify-content: space-between; align-items: center;
          flex-wrap: wrap; gap: 12px;
          padding-top: 20px;
          border-top: 1px solid #f1f5f9;
        }
        .si-back-btn {
          display: inline-flex; align-items: center; gap: 6px;
          font-family: 'Plus Jakarta Sans', sans-serif;
          font-size: 13px; font-weight: 600;
          color: #64748b; background: none; border: none; cursor: pointer; padding: 0;
          transition: color 0.18s;
        }
        .si-back-btn:hover { color: #0f172a; }

        /* ── Responsive ── */
        @media (max-width: 960px) {
          .si-box { max-width: 480px; }
        }

        @media (max-width: 600px) {
          .si-outer { align-items: flex-start; }
          .si-box { max-width: 100%; }
          .si-title { font-size: 22px; }
          .si-hd { margin-bottom: 26px; }
          .si-inp { font-size: 16px; padding: 14px 44px 14px 42px; }
          .si-btn { padding: 15px 20px; font-size: 15px; }
          .si-otp-group { gap: 8px; }
          .si-otp-inp { width: 46px; height: 54px; font-size: 20px; border-radius: 12px; }
          .si-otp-footer { flex-direction: column-reverse; align-items: center; text-align: center; }
        }

        .tfa2-body { flex:1; overflow-y:auto; overflow-x:hidden; padding:0 10px; }
        .tfa2-body::-webkit-scrollbar { width:4px; }
        .tfa2-body::-webkit-scrollbar-thumb { background:#cbd5e1; border-radius:4px; }

        .tfa2-section { padding:0 0; }
        .tfa2-section--last { border-bottom:none; padding-bottom:10px; }
        .tfa2-section-header { display:flex; align-items:center; gap:10px; margin-bottom:14px; }
        .tfa2-section-num { width:26px; height:26px; border-radius:50%; background:#f1f5f9; color:#64748b; font-size:12px; font-weight:700; display:flex; align-items:center; justify-content:center; flex-shrink:0; }
        .tfa2-section-num--active { background:#eff6ff; color:#2563eb; }
        .tfa2-section-title { font-size:13.5px; font-weight:700; color:#1e293b; }

        .tfa2-app-row { display:flex; gap:10px; margin-bottom:14px; flex-wrap:wrap; }
        .tfa2-app-card { display:flex; align-items:center; gap:10px; background:#f8fafc; border:1.5px solid #e2e8f0; border-radius:11px; padding:10px 14px; flex:1; min-width:150px; transition:border-color .15s; }
        .tfa2-app-card:hover { border-color:#93c5fd; }
        .tfa2-app-icon { width:34px; height:34px; border-radius:9px; background:linear-gradient(135deg,#eff6ff,#dbeafe); display:flex; align-items:center; justify-content:center; color:#2563eb; flex-shrink:0; }
        .tfa2-app-name { font-size:12.5px; font-weight:700; color:#0f172a; margin-bottom:2px; }
        .tfa2-app-platforms { font-size:11px; color:#94a3b8; font-weight:500; }

        .tfa2-steps-list { list-style:none; padding:0; margin:0; display:flex; flex-direction:column; gap:6px; }
        .tfa2-steps-list li { font-size:12.5px; color:#475569; line-height:1.5; display:flex; gap:8px; }
        .tfa2-steps-list li::before { content:'→'; color:#93c5fd; font-size:12px; margin-top:1px; flex-shrink:0; }

        .tfa2-qr-wrap { display:flex; gap:18px; align-items:flex-start; flex-wrap:wrap; }
        .tfa2-qr-frame { background:#fff; border:2px solid #e2e8f0; border-radius:13px; padding:10px; flex-shrink:0; box-shadow:0 2px 10px rgba(0,0,0,.06); }
        .tfa2-qr-img { width:130px; height:130px; display:block; }
        .tfa2-qr-meta { flex:1; min-width:0; display:flex; flex-direction:column; gap:12px; }
        .tfa2-qr-hint { font-size:12.5px; color:#64748b; line-height:1.55; }

        .tfa2-key-row { display:flex; flex-direction:column; gap:5px; }
        .tfa2-key-label { display:flex; align-items:center; gap:6px; font-size:11px; font-weight:700; color:#374151; text-transform:uppercase; letter-spacing:0.4px; }
        .tfa2-key-badge { font-size:10px; font-weight:600; text-transform:none; background:#fef3c7; color:#92400e; border:1px solid #fde68a; border-radius:100px; padding:2px 8px; letter-spacing:0; }
        .tfa2-key-value-row { display:flex; align-items:center; gap:8px; background:#f8fafc; border:1.5px solid #e2e8f0; border-radius:9px; padding:8px 12px; min-width:0; overflow:hidden; }
        .tfa2-key-code { font-family:'Courier New',monospace; font-size:12.5px; color:#1e293b; font-weight:600; flex:1 1 0%; min-width:0; overflow:hidden; text-overflow:ellipsis; white-space:nowrap; letter-spacing:.5px; word-break:break-all; }
        .tfa2-copy-btn { display:inline-flex; align-items:center; gap:5px; font-family:'Plus Jakarta Sans',sans-serif; font-size:11.5px; font-weight:600; padding:5px 10px; border-radius:7px; border:1.5px solid #e2e8f0; background:#fff; color:#64748b; cursor:pointer; transition:all .15s; flex-shrink:0; }
        .tfa2-copy-btn:hover { border-color:#93c5fd; color:#2563eb; background:#eff6ff; }
        .tfa2-copy-btn--copied { border-color:#bbf7d0; color:#15803d; background:#f0fdf4; }

        .tfa2-verify-hint { font-size:12.5px; color:#64748b; margin-bottom:16px; line-height:1.5; }
        .tfa2-otp-row { display:flex; gap:10px; justify-content:center; margin-bottom:12px; }
        .tfa2-otp-box { width:54px; height:62px; background:#f8fafc; border:1.5px solid #e2e8f0; border-radius:14px; font-family:'Plus Jakarta Sans',sans-serif; font-size:24px; font-weight:700; color:#0f172a; text-align:center; outline:none; transition:border-color .18s, box-shadow .18s, background .18s; caret-color:#2563eb; }
        .tfa2-otp-box:focus { border-color:#2563eb; background:#fff; box-shadow:0 0 0 3px rgba(37,99,235,.1); }
        .tfa2-otp-box--filled { border-color:#93c5fd; background:#eff6ff; color:#1d4ed8; }
        .tfa2-otp-err { display:flex; align-items:center; justify-content:center; gap:5px; font-size:12px; color:#dc2626; font-weight:500; margin-top:4px; }

        .tfa2-footer { padding:14px 24px; border-top:1.5px solid #f1f5f9; background:#fafbfc; display:flex; align-items:center; justify-content:space-between; flex-wrap:wrap; gap:10px; flex-shrink:0; }
        .tfa2-footer-note { display:flex; align-items:center; gap:6px; font-size:12px; color:#94a3b8; font-weight:500; }
        .tfa2-footer-btns { display:flex; align-items:center; gap:10px; }
        .tfa2-btn-cancel { font-family:'Plus Jakarta Sans',sans-serif; font-size:13px; font-weight:600; color:#64748b; padding:9px 16px; border-radius:10px; border:1.5px solid #e2e8f0; background:#fff; cursor:pointer; transition:all .15s; }
        .tfa2-btn-cancel:hover { background:#f1f5f9; color:#374151; }
        .tfa2-btn-verify { display:inline-flex; align-items:center; gap:7px; font-family:'Plus Jakarta Sans',sans-serif; font-size:13.5px; font-weight:700; color:#fff; padding:10px 20px; border-radius:10px; border:none; background:linear-gradient(135deg,#1d4ed8,#2563eb); cursor:pointer; box-shadow:0 4px 14px rgba(37,99,235,.3); transition:transform .15s, box-shadow .18s; position:relative; overflow:hidden; }
        .tfa2-btn-verify::after { content:''; position:absolute; inset:0; background:linear-gradient(135deg,rgba(255,255,255,.1),transparent 60%); }
        .tfa2-btn-verify:hover { transform:translateY(-1px); box-shadow:0 8px 24px rgba(37,99,235,.38); }
        .tfa2-btn-verify:disabled { opacity:.6; cursor:not-allowed; transform:none; }
        .tfa2-spinner { display:inline-block; width:16px; height:16px; border:2px solid rgba(255,255,255,.35); border-top-color:#fff; border-radius:50%; animation:tfa2Spin .65s linear infinite; }
        @keyframes tfa2Spin { to{transform:rotate(360deg)} }

        @media (max-width:600px) {
          .tfa2-panel { max-width:100%; }
          .tfa2-header, .tfa2-footer { padding-left:18px; padding-right:18px; }
          .tfa2-body { padding:0 18px; }
          .tfa2-qr-wrap { flex-direction:column; align-items:stretch; }
          .tfa2-qr-frame { align-self:center; }
          .tfa2-qr-meta { min-width:0; width:100%; }
          .tfa2-key-value-row { flex-wrap:nowrap; }
          .tfa2-otp-box { width:44px; height:52px; font-size:20px; }
          .tfa2-otp-row { gap:7px; }
          .tfa2-footer-btns { width:100%; justify-content:flex-end; }
          .tfa2-footer-note { display:none; }
        }
        @media (max-width:420px) {
          /* Key row: shrink copy button to icon only */
          .tfa2-copy-btn span { display:none; }
          .tfa2-copy-btn { padding:5px 7px; gap:0; }
          .tfa2-key-code { font-size:11px; letter-spacing:0.2px; }
          .tfa2-key-value-row { padding:7px 10px; }
        }
        @media (max-width:380px) {
          .tfa2-otp-box { width:38px; height:46px; font-size:17px; border-radius:10px; }
          .tfa2-otp-row { gap:5px; }
          .tfa2-key-code { font-size:10.5px; }
        }

        @media (max-width: 380px) {
          .si-otp-inp { width: 40px; height: 48px; font-size: 18px; border-radius: 10px; }
          .si-otp-group { gap: 6px; }
        }
      `}</style>
    </div>
  );
}